export const visit = (vm, at) => {
vm(require("foundations-components/lang/ms.lyaml"));
at({ "ms": { "placeholder": "ruang letak" } });
};